import type { ComponentPropsWithoutRef } from "react";
import { styled } from "styled-components";

import { ChevronIcon, UIButton } from "common/components";
import { useTranslate } from "common/utilities/useTranslate";

const StyledChevron = styled(ChevronIcon)<{ $showSeeMore: boolean }>`
  transform: rotate(${({ $showSeeMore }) => ($showSeeMore ? "90deg" : "270deg")});
  height: 15px;
  width: 15px;
  margin-left: 1rem;
  transition: transform 0.3s;
`;

type LoadMoreButtonProps = ComponentPropsWithoutRef<"button"> & { filterCount?: number; showSeeMore?: boolean };

export const LoadMoreButton = ({
  children,
  filterCount: _filterCount,
  showSeeMore = true,
  ...props
}: LoadMoreButtonProps) => {
  const translate = useTranslate();
  return (
    <UIButton variant="neutral" {...props} style={{ margin: "0 auto" }}>
      {children}
      {translate(showSeeMore ? "app.action.see_more" : "app.action.see_less")}
      <StyledChevron $showSeeMore={showSeeMore} />
    </UIButton>
  );
};
